import { api } from "@/shared/api";

/**
 * 个性化 skill 网格卡片。name=ai builtin 目录名(点卡意图);label=中文名(后端 catalog join);
 * description=话术(overlay-merged);billing=计费口径(前端可标「省积分/需积分」)。
 */
export interface SkillCard {
  name: string;
  label: string;
  description: string;
  billing: string;
  /** D2*:业务域(分组);recommended=常用(渐进披露首屏直显)。老后端未回时前端兜底。 */
  category?: string;
  recommended?: boolean;
  /** ADV-UI-5:能力目录五段稿(guidance_reviewed 版)。老后端/老 ai 未回时缺省,卡片不展开。 */
  guidance?: SkillGuidance;
  /**
   * ADV-HUB-SYNC-1:这张能力卡由**哪门手艺**执行(ai execution.skill;引导类卡为空串)。
   * hub 技能管理页(按手艺列)据此反查名下能力,与对话抽屉共用同一份 /advisor/skills 数据。
   * 老后端未回 → undefined,反查得空 → 管理页只是不挂目录,不炸。
   */
  skill?: string;
}

/** 五段稿(ai capabilities/registry.yaml 单一源;文案原样渲染零加工)。 */
export interface SkillGuidance {
  mode: "EXECUTE" | "REDIRECT" | "GUIDE";
  detail: string;
  cost: string;
  scenarios: string[];
  suitableFor: string[];
  /** 逐条自带「→ 去处」(REDIRECT 的「改推谁」就在这里),原样渲染。 */
  notSuitableFor: string[];
  inputRequired: string[];
  inputOptional: string[];
  examples: string[];
}

/**
 * skill 网格 thin api。GET 拿该用户可见 skill(后端过硬闸 + list_for role/overlay 过滤 + label join +
 * 租户 disabled 过滤)。同源 backend `/api/v1/advisor/skills`。
 */
export const advisorGridApi = {
  list: () => api.get<SkillCard[]>("/advisor/skills"),
};
